import { StyleSheet } from "react-native";
import { theme } from "../../../theme/theme";
const style = () => {
    const { colorIconSuccess, colorIconError, colorIconOnPrimary, colorContent, space2, space4, shadowColor, shadowOffset, elevationOpacityM, shadowRadius, } = theme();
    return StyleSheet.create({
        body: {
            color: colorContent,
        },
        button: {
            marginLeft: space2,
            padding: space4,
        },
        content: {
            flex: 1,
            padding: space4,
        },
        error: {
            backgroundColor: colorIconError,
        },
        info: {
            backgroundColor: colorIconOnPrimary,
        },
        success: {
            backgroundColor: colorIconSuccess,
        },
        title: {
            marginBottom: space2,
        },
        toast: {
            alignItems: "center",
            flexDirection: "row",
            shadowColor: shadowColor,
            shadowOffset: shadowOffset,
            shadowOpacity: elevationOpacityM,
            shadowRadius: shadowRadius,
        },
    });
};
export { style };
